import { DocumentNode, FieldNode, OperationDefinitionNode, SelectionNode, StringValueNode } from 'graphql/language/ast';
import { FilterConfig } from 'src/utils/composeFilter.ts';

const collectFields = (selections: readonly SelectionNode[], opName: string): FilterConfig => {
    if (!Array.isArray(selections)) {
        return [];
    }
    return selections.reduce((acc, curr: FieldNode) => {
        const out = [...acc];
        if (curr.name && curr.name.value === opName) {
            if (curr.arguments) {
                const [{ value }] = curr.arguments;
                if (curr.alias) {
                    out.push([curr.alias.value, (value as StringValueNode).value]);
                }
            }
        }
        const inner = collectFields(curr.selectionSet?.selections || [], opName);
        return [...out, ...inner];
    }, [] as FilterConfig);
};

export const generateFiltersConfig = (document: DocumentNode, opName = 'values'): FilterConfig => {
    const { definitions } = document;
    const [definition] = definitions as ReadonlyArray<OperationDefinitionNode>;
    const { selectionSet } = definition;
    return collectFields(selectionSet.selections, opName);
};
